import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, Link } from "react-router-dom";

export default function Header() {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuActive, setIsMenuActive] = useState(false);

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
    setIsOpen(false);
  };

  const closeMenu = () => {
    setIsMenuActive(false);
  };

  return (
    <header
      id="header"
      className="relative flex flex-col shadow-[0px_0px_10px_#00000021] relative z-10 transition-all duration-300 flex flex-col"
    >
      <div className="bg-[#242830]">
        <div className="container flex justify-end gap-[30px] py-[10px]">
          <div className="flex items-center gap-[5px]">
            <img
              className="w-[20px] h-[20px]"
              src={require("../../assets/icons/phone.svg").default}
              alt=""
            />
            <span className="text-white f-13-px">026413666</span>
          </div>
          <div className="flex items-center gap-[5px]">
            <img
              className="w-[20px] h-[20px]"
              src={require("../../assets/icons/location.svg").default}
              alt=""
            />
            <span className="text-white f-13-px">
              {t("Al Wahda Commercial Tower, Office No. 101")}
            </span>
          </div>
        </div>
      </div>
      <div className="relative container py-[20px] flex items-center justify-between">
        <Link to={"/"}>
          <img
            className="w-[115px]"
            src={require("../../assets/logo/logo.svg").default}
            alt="Logo"
          />
        </Link>
        <nav className="d-none">
          <ul className="flex items-center gap-[10px]">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Home")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("About us")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Services")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/our-team"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Our Team")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact-us"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Contact us")}
              </NavLink>
            </li>
          </ul>
        </nav>

        <div className="flex items-center gap-[8px]">
          <div className="flex items-center gap-[10px]">
            <div className="relative">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2 p-2 text-[#666666] font-bold rounded-md capitalize"
              >
                <img
                  className="w-[35px] h-[35px]"
                  src={require("../../assets/icons/language.svg").default}
                  alt="Language"
                />
              </button>
              {isOpen && (
                <div className="rr absolute right-100 right-0 mt-2 w-40 bg-white shadow-lg rounded-md z-100">
                  <div className="py-1">
                    <button
                      onClick={() => changeLanguage("en")}
                      className="w-full flex items-center gap-[5px] text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-t-md"
                    >
                      <div>English</div>
                    </button>
                    <button
                      onClick={() => changeLanguage("ar")}
                      className="w-full flex items-center gap-[5px] text-left px-4 py-2 text-[#666666] hover:bg-gray-200 rounded-b-md"
                    >
                      <div>العربية</div>
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="d-none flex items-center gap-[10px]"></div>
            <button
              className={`menu ${isMenuActive ? "active" : ""}`}
              onClick={toggleMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <Link
            to={"/company-profile"}
            className="d-none text-white bg-[#3896BE] rounded-[8px] py-[8px] px-[25px] font-bold"
          >
            {t("Company Profile")}
          </Link>
        </div>
      </div>
      {isMenuActive && (
        <nav className="flex flex-col gap-[20px] relative left-0 bg-white w-full p-5 h-[84vh]">
          <ul className="flex flex-col gap-4">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Home")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("About us")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Services")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/our-team"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Our Team")}
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact-us"
                className={({ isActive }) =>
                  `px-[3px] py-2 ${
                    isActive
                      ? "text-[#3896BE] font-bold capitalize"
                      : "text-black"
                  } hover:text-[#3896BE] font-bold transition duration-500 capitalize`
                }
                onClick={closeMenu}
              >
                {t("Contact us")}
              </NavLink>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
